import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import '../../../../assets/css/authenticationStyles.css';
import notap_logo from '../../../../assets/images/notap_logo.png';
import {
  clearAll,
  onVerifyLink,
  setErrorMessageBankUser,
  setLoadingBankUser,
  showDocumentViewerModalFunc,
} from '../../../../config/redux/slice/bankUserSlice'
import { postRequest, getRequest } from '../../../../helpers/request';
import { appApi } from '../../../../utils/endpoints/appApi';
import { appUrls } from '../../../../utils/urls/appUrls';
import { AuthAlert, Spinner } from '../../../components';
import { decryptToken } from '../../../../helpers/helpers';
import CertificateManagement from './CertificateManagement';
import CertificateOfReasonablenessUploadForm from './CertificateUploadForm';
import DocumentViewerModal from './DocumentViewerModal';

export default function OTPVerification() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {encryted_email, reference_number} = useParams()
  const {register, handleSubmit, formState: {errors}} = useForm({mode: 'onTouched'})
  const {
        token,
    } = useSelector((state) => state.authData)
    const [showReasonablenessForm, setShowReasonablenessForm] = useState(false)
    const [certificateObject, setCertificateObject] = useState({})

  const {
        bankUserLoading,
        bankUserErrorMsg,
        bankUserSuccessMsg,
        certificateManagement:{certificatesData, newData, document_url, showDocumentViewerModal, showCertificateForm, additionalDocs}
    } = useSelector((state) => state.bankUser)  

    const [banks, setBanks] = useState([])


    // const getBanks = async () =>{
    //   const res = await getRequest(
    //     token,
    //     `${appApi.banks}`,
    //     {},
    //     dispatch,
    //     "",
    //     "",
    //     ""
    //   )
    //   if(res !== undefined && res.status < 400){
    //       setBanks(res.data.data)
    //   }
    // }

    const verifyLink = async (data) => {
      dispatch(clearAll({}))
      // let email = decryptToken(encryted_email)
        const res = await postRequest(
            "",
            `${appApi.verifyLink}`,
            {...data,
              email: encodeURIComponent(encryted_email),
              reference: reference_number
            },
            dispatch,
            setLoadingBankUser,
            "",
            ""
        )
        if(res !== undefined && res.status < 400){
          setCertificateObject(res.data.data)
          dispatch(onVerifyLink({otp: data.otp, reference: reference_number}))
          setShowReasonablenessForm(true)
        }else if(res.status >= 400){
          navigate(appUrls.upload_link_verification_error)
        }
    }

    // const onSubmit = async (data) => {
    //     dispatch(clearAll({}))
    //     const res = await postRequest(
    //         token,
    //         `${appApi.profile_creation}`,
    //         data,
    //         dispatch,
    //         setLoading,
    //         onUserLogin,
    //         setErrorMessage
    //     )
    //     if(res !== undefined && res.status < 400){
    //       navigate(appUrls.profileCreationSuccess)
    //     }
    // }

    const closeAlert = () => {
        dispatch(setErrorMessageBankUser({message: null}))
    }

  return (
    <>
      {showReasonablenessForm ? 
      <div>
        <CertificateOfReasonablenessUploadForm certificateObject={certificateObject} backdrop={true}/>
        {showDocumentViewerModal && <DocumentViewerModal filePath={document_url}/>}
        <CertificateManagement callEndpoint={false}/>
      </div> :
    <div className='d-flex justify-content-center align-items-baseline profile-creation'>
      <div style={{marginTop: '2rem'}}  className='card card-default pt-5 px-5 pb-0'>
        <div className='formContainer'>
            <div style={{columnGap: '1rem'}} className='d-flex align-items-center justify-content-center'>
              <img src={notap_logo} alt='logo' className='logotypeImage' />
              <h2 className='font-weight-bold'>
                NOTAP Portal
              </h2>              
            </div>
            <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
              <p style={{fontSize: '1.3rem'}} className={`text-capitalize`}>
                Enter Your One Time Password
              </p>
            </div>
            <form className='mainForm' onSubmit={handleSubmit(verifyLink)}>
              <div className="row w-100 m-0">
                <div className="form-group col-md-12 mb-4">
                    <label htmlFor='otp'>One Time Password (OTP)</label>
                    <input 
                    type="text" 
                    className="form-control input-lg" 
                    id="otp" 
                    aria-describedby="otpHelp"
                    {...register("otp", {
                        required: {
                        value: true,
                        message: '*this field is required'
                        }
                    })
                    }
                    />
                    {
                    errors?.otp?.message &&
                    <div className="text-danger small mt-1">
                        {errors?.otp?.message}
                    </div>
                    }
                </div>           
                <div className="col-md-12">

                    <div>
                    {bankUserLoading ? 
                        <Spinner/> :
                        <button type="submit" className="btn btn-primary mb-4">Submit</button>
                    }
                    </div>
                </div>
              </div>
            </form>
        </div>        
      </div>        
    </div>}
    </>
  )
}
